<template>
  <div class="billing-report-page">
    <h6>Movimentação do Caixa</h6>
    <div class="columns">
      <div class="column col-3 col-md-4 col-sm-12 form-group"
           :class="{'has-error': $v.filters.startDate.$error}">
        <label class="form-label">Data início</label>
        <div class="input-group">
          <dx-input-date
            id="appointment-patient-birth-date"
            class="form-input text-center"
            v-model="filters.startDate"
            @blur="$v.filters.startDate.$touch()"
          />
        </div>
        <template v-if="$v.filters.startDate.$error">
          <div class="form-input-hint"
               v-if="!$v.filters.startDate.required">Campo obrigatório</div>
          <div class="form-input-hint"
               v-else-if="!$v.filters.startDate.date" >Data inválida</div>
        </template>
      </div>
      <div class="column col-3 col-md-4 col-sm-12 form-group"
           :class="{'has-error': $v.filters.endDate.$error}">
        <label class="form-label">Data término</label>
        <dx-input-date
          id="end-date"
          class="form-input text-center"
          v-model="filters.endDate"
          @blur="$v.filters.endDate.$touch()"
        />
        <template v-if="$v.filters.endDate.$error">
          <div class="form-input-hint"
               v-if="!$v.filters.endDate.required">Campo obrigatório</div>
          <div class="form-input-hint"
               v-else-if="!$v.filters.endDate.date" >Data inválida</div>
        </template>
      </div>
      <div class="column col-3 col-md-4 col-sm-12 form-group">
        <label for="date-type" class="form-label">Data seleção</label>
        <select id="date-type" class="form-select" v-model="filters.dateType">
          <option value="payment">Data da movimentação</option>
          <option value="service">Data do atendimento</option>
        </select>
      </div>
      <div class="column col-3 col-md-4 col-sm-12 form-group">
        <label for="report-type" class="form-label">Modalidade</label>
        <select id="report-type" class="form-select" v-model="filters.type">
          <option value="cashier-summary">Caixa - Resumido</option>
          <option value="cashier-detailed">Caixa - Detalhado</option>
          <option value="payment-summary">Forma de pgto - Resumido</option>
          <option value="payment-detailed">Forma de pgto - Detalhado</option>
        </select>
      </div>
    </div>
    <div class="billing-list">
      <div class="scroll-list-wrapper">
        <div class="scroll-list">
          <div class="list-header">
            <label class="form-checkbox">
              <input type="checkbox"
                     @change="selectAllCashiers"
                     :checked="getCashiersSelected"
                     :indeterminate.prop="getCashiersSelected === null">
              <i class="form-icon"></i>
            </label>
            <div class="list-title">Caixas</div>
            <div class="input-group">
              <input type="text" class="form-input"
                     v-model="filters.cashier"
                     placeholder="Filtrar caixa">
              <button class="btn btn-neutral btn-action input-group-btn btn-icon"
                      tabindex="-1" v-if="!filters.cashier.trim()">
                <fa-icon :icon="['fal', 'search']"/>
              </button>
              <button class="btn btn-gray input-group-btn btn-icon"
                      @click="filters.cashier = ''"
                      tabindex="-1" v-else>
                <fa-icon :icon="['fal', 'times']"/>
              </button>
            </div>
          </div>
          <table class="table table-hover">
            <tbody>
            <tr v-for="(item, i) in filteredCashiers" :key="i">
              <td width="30px">
                <label class="form-checkbox">
                  <input type="checkbox" v-model="item.selected">
                  <i class="form-icon"></i>
                </label>
              </td>
              <td>{{ item.name }}</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="scroll-list-wrapper">
        <div class="scroll-list">
          <div class="list-header">
            <label class="form-checkbox">
              <input type="checkbox"
                     @change="selectAllInsurances"
                     :checked="getInsurancesSelected"
                     :indeterminate.prop="getInsurancesSelected === null">
              <i class="form-icon"></i>
            </label>
            <div class="list-title">Convênios</div>
            <div class="input-group">
              <input type="text" class="form-input"
                     v-model="filters.insurance"
                     placeholder="Filtrar convênio">
              <button class="btn btn-neutral btn-action input-group-btn btn-icon"
                      tabindex="-1" v-if="!filters.insurance.trim()">
                <fa-icon :icon="['fal', 'search']"/>
              </button>
              <button class="btn btn-gray input-group-btn btn-icon"
                      @click="filters.insurance = ''"
                      tabindex="-1" v-else>
                <fa-icon :icon="['fal', 'times']"/>
              </button>
            </div>
          </div>
          <table class="table table-hover">
            <tbody>
            <tr v-for="(item, i) in filteredInsurances" :key="i">
              <td width="30px">
                <label class="form-checkbox">
                  <input type="checkbox" v-model="item.selected">
                  <i class="form-icon"></i>
                </label>
              </td>
              <td>{{ item.name }}</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="scroll-list-wrapper">
        <div class="scroll-list">
          <div class="list-header">
            <label class="form-checkbox">
              <input type="checkbox"
                     @change="selectAllPaymentMethods"
                     :checked="getPaymentMethodsSelected"
                     :indeterminate.prop="getPaymentMethodsSelected === null">
              <i class="form-icon"></i>
            </label>
            <div class="list-title">Forma de pagamento</div>
            <div class="input-group">
              <input type="text" class="form-input"
                     v-model="filters.paymentMethod"
                     placeholder="Filtrar forma de pagamento">
              <button class="btn btn-neutral btn-action input-group-btn btn-icon"
                      tabindex="-1" v-if="!filters.paymentMethod.trim()">
                <fa-icon :icon="['fal', 'search']"/>
              </button>
              <button class="btn btn-gray input-group-btn btn-icon"
                      @click="filters.paymentMethod = ''"
                      tabindex="-1" v-else>
                <fa-icon :icon="['fal', 'times']"/>
              </button>
            </div>
          </div>
          <table class="table table-hover">
            <tbody>
            <tr v-for="(item, i) in filteredPaymentMethods" :key="i">
              <td width="30px">
                <label class="form-checkbox">
                  <input type="checkbox" v-model="item.selected">
                  <i class="form-icon"></i>
                </label>
              </td>
              <td>{{ item.name }}</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="footer">
      <button class="btn btn-primary btn-icon-left"
              :class="{loading: printing}"
              @click="print" :disabled="printing">
        <fa-icon :icon="['fal', 'print']"></fa-icon>Imprimir
      </button>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { required } from 'vuelidate/lib/validators';
import { date, minDate } from '@/data/validators';
import fuzzy from 'fuzzy';
import formMixin from '@/mixins/form';

export default {
  mixins: [formMixin],
  data() {
    return {
      printing: false,
      cashierItems: [],
      insuranceItems: [],
      paymentMethodItems: [],
      filters: {
        type: 'cashier-detailed',
        dateType: 'payment',
        startDate: '',
        endDate: '',
        paymentMethod: '',
        insurance: '',
        cashier: '',
      },
    };
  },
  validations() {
    const rules = {
      filters: {
        startDate: { date, required },
        endDate: { date, required },
      },
    };
    if (this.filters.startDate) {
      rules.filters.endDate = {
        date,
        required,
        minDate: minDate(this.filters.startDate),
      };
    }
    return rules;
  },
  mounted() {
    this.filters.startDate = moment().startOf('month').format('YYYY-MM-DD');
    this.filters.endDate = moment().endOf('month').format('YYYY-MM-DD');
    this.loadInsurances();
    this.loadCashiers();
    this.loadPaymentMethods();
  },
  computed: {
    getInsurancesSelected() {
      if (!this.filteredInsurances || this.filteredInsurances.length === 0) {
        return false;
      }

      const insurancesSelected = this.filteredInsurances.filter(item => item.selected);
      if (insurancesSelected.length === 0) {
        return false;
      }
      if (insurancesSelected.length === this.filteredInsurances.length) {
        return true;
      }
      return null;
    },
    getCashiersSelected() {
      if (!this.filteredCashiers || this.filteredCashiers.length === 0) {
        return false;
      }

      const cashiersSelected = this.filteredCashiers.filter(item => item.selected);
      if (cashiersSelected.length === 0) {
        return false;
      }
      if (cashiersSelected.length === this.filteredCashiers.length) {
        return true;
      }
      return null;
    },
    getPaymentMethodsSelected() {
      if (!this.filteredPaymentMethods || this.filteredPaymentMethods.length === 0) {
        return false;
      }

      const paymentMethodsSelected = this.filteredPaymentMethods.filter(item => item.selected);
      if (paymentMethodsSelected.length === 0) {
        return false;
      }
      if (paymentMethodsSelected.length === this.filteredPaymentMethods.length) {
        return true;
      }
      return null;
    },
    filteredPaymentMethods() {
      let { paymentMethodItems } = this;

      if (this.filters.paymentMethod.trim()) {
        const results = fuzzy.filter(this.filters.paymentMethod, paymentMethodItems, {
          extract: (el) => {
            if (el.name) {
              return this.removeAccentuation(el.name);
            }
            return '';
          },
        });
        paymentMethodItems = results.map(({ original }) => original);
      }

      return paymentMethodItems;
    },
    filteredCashiers() {
      let { cashierItems } = this;

      if (this.filters.cashier.trim()) {
        const results = fuzzy.filter(this.filters.cashier, cashierItems, {
          extract: (el) => {
            if (el.name) {
              return this.removeAccentuation(el.name);
            }
            return '';
          },
        });
        cashierItems = results.map(({ original }) => original);
      }

      return cashierItems;
    },
    filteredInsurances() {
      let { insuranceItems } = this;

      if (this.filters.insurance.trim()) {
        const results = fuzzy.filter(this.filters.insurance, insuranceItems, {
          extract: (el) => {
            if (el.name) {
              return this.removeAccentuation(el.name);
            }
            return '';
          },
        });
        insuranceItems = results.map(({ original }) => original);
      }

      return insuranceItems;
    },
  },
  methods: {
    selectAllInsurances(e) {
      this.filteredInsurances.forEach((item) => {
        item.selected = e.target.checked;
      });
    },
    selectAllCashiers(e) {
      this.filteredCashiers.forEach((item) => {
        item.selected = e.target.checked;
      });
    },
    selectAllPaymentMethods(e) {
      this.filteredPaymentMethods.forEach((item) => {
        item.selected = e.target.checked;
      });
    },
    loadInsurances() {
      const params = {
        limit: 0,
        active: true,
      };
      return this.$http.get('/insurance-plans', { params })
        .then(({ data }) => {
          this.insuranceItems = data.items.map(item => ({
            id: item.plan.id,
            name: item.customName,
            selected: true,
          }));
        })
        .catch(() => {});
    },
    loadCashiers() {
      const params = {
        cashier: true,
        active: true,
        limit: 0,
      };
      return this.$http.get('/bank-accounts', { params })
        .then(({ data }) => {
          this.cashierItems = data.items.map(item => ({
            id: item.id,
            name: item.name,
            selected: true,
          }));
        })
        .catch(() => {})
        .then(() => {
          this.loading = false;
        });
    },
    loadPaymentMethods() {
      const params = {
        limit: 0,
        active: true,
      };
      return this.$http.get('/payment-methods', { params })
        .then(({ data }) => {
          this.paymentMethodItems = data.items.map(item => ({
            id: item.id,
            name: item.name,
            selected: true,
          }));
          this.paymentMethodItems.push({
            id: '000000000000000000000000',
            name: 'Cortesia',
            selected: true,
          });
          this.paymentMethodItems.sort((a, b) => {
            if (a.name > b.name) return 1;
            if (a.name < b.name) return -1;
            return 0;
          });
        })
        .catch(() => {});
    },
    print() {
      this.$v.filters.$touch();
      if (this.$v.filters.$error) {
        return false;
      }

      this.printing = true;

      const params = {
        startDate: this.filters.startDate,
        endDate: this.filters.endDate,
        type: this.filters.type,
        dateType: this.filters.dateType,
        insuranceIds: this.insuranceItems
          .filter(({ selected }) => selected)
          .map(item => item.id).join(','),
        cashierIds: this.cashierItems
          .filter(({ selected }) => selected)
          .map(item => item.id).join(','),
        paymentMethodIds: this.paymentMethodItems
          .filter(({ selected }) => selected)
          .map(item => item.id).join(','),
      };

      return this.$file
        .print('/reports/cashier-demonstrative', params)
        .catch(() => {})
        .then(() => {
          this.printing = false;
        });
    },
  },
};
</script>

<style lang="scss">
@import "../../../assets/scss/variables";
@import '~assets/scss/mixins';
.billing-report-page {
  .billing-list {
    display: flex;
    flex-direction: column;
    height: 40rem;
    overflow-y: auto;
    .list-header {
      align-items: center;
      border-bottom: $border-width solid $border-color;
      display: flex;
      padding-bottom: $layout-spacing;
      .list-title {
        flex: 1;
        font-weight: bold;
      }
    }
    .scroll-list-wrapper {
      border: $border-color solid $border-width;
      border-radius: $border-radius;
      flex-grow: 1;
      margin-bottom: $layout-spacing-lg * 2;
      position: relative;
    }
    .scroll-list {
      bottom: 0;
      overflow-y: auto;
      padding: $layout-spacing $layout-spacing-lg;
      position: absolute;
      top: 0;
      width: 100%;
      @include scroll-bar();
      .table th, .table td {
        padding: 0;
      }
      .table td {
        border-bottom: none;
      }
    }
  }
  .footer {
    text-align: right;
  }
}
</style>
